/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Settings_Files_Delete_Dialog_Description_SingleInputs */

const es_settings_files_delete_dialog_description_single = /** @type {(inputs: Settings_Files_Delete_Dialog_Description_SingleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`"${i?.name}" será eliminado permanentemente y no podrá recuperarse.`)
};

const en_settings_files_delete_dialog_description_single = /** @type {(inputs: Settings_Files_Delete_Dialog_Description_SingleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`"${i?.name}" will be permanently removed and cannot be recovered.`)
};

/**
* | output |
* | --- |
* | "\"{name}\" will be permanently removed and cannot be recovered." |
*
* @param {Settings_Files_Delete_Dialog_Description_SingleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_files_delete_dialog_description_single = /** @type {((inputs: Settings_Files_Delete_Dialog_Description_SingleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Files_Delete_Dialog_Description_SingleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_files_delete_dialog_description_single(inputs)
	return en_settings_files_delete_dialog_description_single(inputs)
});
export { settings_files_delete_dialog_description_single as "settings.files.delete_dialog.description_single" }